import React from 'react';
import './App.css';
import { useNavigate } from 'react-router-dom';

const services = [
  {
    img: 'images/claim-insurance-2109232-1773238.png',
    title: 'CLAIM TOKEN',
    desc: 'Completely supports decentralized tokens',
  },
  {
    img: 'images/images.jpg',
    title: 'CLAIM  AIRDROP',
    desc: 'Claim airdrop without stress',
  },
  {
    img: 'images/5261394.png',
    title: 'RECTIFICATION',
    desc: 'Rectification support warranties completely decentralized',
  },
  {
    img: 'images/5145695.png',
    title: 'VALIDATION',
    desc: 'Validation completely decentralized supports wallet',
  },
  {
    img: 'images/4293689.png',
    title: 'RECOVERY',
    desc: 'Recovery wallet TATs Dapps with Blockchain and DeFi',
  },
  {
    img: 'images/istockphoto-1460711038-612x612.jpg',
    title: 'HARVEST MY STAKINGS',
    desc: 'When you choose to redeem, we’ll return your assets to your Spot Wallet the following day.',
  },
  {
    img: 'images/1682308.png',
    title: 'MIGRATION',
    desc: 'Migrate crypto balance off to an external crypto wallet',
  },
  {
    img: 'images/4414180.webp',
    title: 'STAKING POOL',
    desc: 'Withdraw crypto balance off to an external crypto wallet',
  },
  {
    img: 'images/2495429-2001.png',
    title: 'CLEAR CACHE',
    desc: 'Clear my cache Files',
  },
  {
    img: 'images/2168118.png',
    title: 'ADD TOKENS',
    desc: 'Crypto tokens are a type of currency that represents an asset that reside in blockchain.',
  },
  {
    img: 'images/3491977.webp',
    title: 'UPDATE MY PORTFOLIOS',
    desc: 'Generate Real-Time Profit and Loss Reports, Your Coin Values, Reports for Taxes and More.',
  },
  {
    img: 'images/5068176-200.png',
    title: 'PURCHASE TOKEN',
    desc: 'Also, buy bitcoin, ether, and many common cryptocurrencies.',
  },
  {
    img: 'images/2495429-2001.png',
    title: 'MY NFTS',
    desc: 'View your collection of digital works.',
  },
  {
    img: 'images/proof-stake-pos-icon-crypto-staking-concept-vector_32996-2406.png',
    title: 'STAKING REVIEW',
    desc: 'Having complete control of your staking',
  },
  {
    img: 'images/bridge-coin-bco-logo-png_seeklogo-388675.png',
    title: 'BRIDGE',
    desc: 'Enables applications built on blockchains to communicate with each other.',
  },
  {
    img: 'images/2966284-200.png',
    title: 'WHITELIST',
    desc: 'Get an Early Spot for Minting.',
  },
];

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <div className="landing-root">
      {/* Header */}
      <header className="landing-header-bar">
        <h2>Debug<span>AppFix</span></h2>
        <nav>
          <ul>
            <li><a className="active" href="#">Home</a></li>
            <li><a onClick={() => navigate('/wallets')}>Connect Wallet</a></li>
            <li><a href="#contact">Contact Us</a></li>
            <li><a href="#faq">FAQ</a></li>
          </ul>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="landing-hero-section">
        <div className="landing-hero-content">
          <h1><span>Decentralized</span> Platform Wallet</h1>
          <p>DebugAppFix is a powerful tool for wallet validation, essential for ensuring the security and integrity of digital assets. Performs a comprehensive analysis of the wallet's structure and contents, including checks for correct formatting, correct key derivation, and proper encryption.</p>
          <button onClick={() => navigate('/wallets')}>Get Started</button>
        </div>
      </section>

      {/* Services Section */}
      <section className="landing-services-section">
        <div className="landing-services-heading">
          <h2>Services</h2>
          <p>DebugAppFix is a decentralized protocol that creates a secure and resilient open-source software ecosystem for developers to create innovative online tools, targeting global business markets. One of its key features is the validation of wallets.</p>
        </div>
        <a onClick={() => navigate('/wallets')}>
        <div className="landing-services-grid">
          {services.map((service, i) => (
            <div className="landing-service-card" key={i}>
              <img src={service.img} alt={service.title} />
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
        </a>
      </section>

      {/* Contact Section */}
      <section className="landing-contact-section" id="contact">
        <div className="landing-contact-form">
          <h3>Looking for <span>Crypto Liquidity Solutions?</span></h3>
          <span>Get in touch with us</span>
          <form onSubmit={e => e.preventDefault()}>
            <input type="text" name="first" placeholder="First Name" required />
            <input type="text" name="last" placeholder="Last Name" required />
            <input type="text" name="BusinessName" placeholder="Business Name" required />
            <input type="text" name="Phone" placeholder="Phone" required />
            <textarea name="message" cols="30" rows="4" placeholder="Write a message" required></textarea>
            <button type="submit">Submit</button>
          </form>
        </div>
        <div className="landing-contact-img">
          <img src="/contact-image.png" alt="contact" />
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-main">
          <div className="footer-brand">
            <h2>Debug<span>AppFix</span></h2>
            <p>BE PART OF OUR COMMUNITY</p>
            <div className="footer-socials">
              <span className="icon">
                {/* Twitter */}
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3d3dd7" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.25" stroke="#bdbdf7" strokeWidth="1.5" fill="white"/><path d="M19.633 7.997c-.478.212-.992.356-1.53.421a2.66 2.66 0 0 0 1.163-1.47 5.32 5.32 0 0 1-1.687.645 2.654 2.654 0 0 0-4.52 2.418A7.53 7.53 0 0 1 6.16 7.13a2.653 2.653 0 0 0 .822 3.54 2.64 2.64 0 0 1-1.202-.332v.033a2.655 2.655 0 0 0 2.13 2.602c-.24.066-.494.102-.756.102-.185 0-.364-.018-.54-.052a2.66 2.66 0 0 0 2.478 1.844A5.33 5.33 0 0 1 5 17.07a7.52 7.52 0 0 0 4.07 1.193c4.88 0 7.553-4.042 7.553-7.553 0-.115-.003-.23-.008-.344.518-.374.97-.84 1.326-1.373Z" fill="#3d3dd7"/></svg>
              </span>
              <span className="icon">
                {/* LinkedIn */}
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3d3dd7" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.25" stroke="#bdbdf7" strokeWidth="1.5" fill="white"/><rect x="7.5" y="9.5" width="2" height="6" rx="1" fill="#3d3dd7"/><rect x="14.5" y="12" width="2" height="3.5" rx="1" fill="#3d3dd7"/><rect x="7.5" y="7.5" width="2" height="2" rx="1" fill="#3d3dd7"/><rect x="11" y="12" width="2.5" height="1.5" rx="0.75" fill="#3d3dd7"/></svg>
              </span>
              <span className="icon">
                {/* Telegram */}
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3d3dd7" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.25" stroke="#bdbdf7" strokeWidth="1.5" fill="white"/><path d="M17.5 8.5 10.5 15.5 8.5 13.5" stroke="#3d3dd7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M17.5 8.5 6.5 12l3 1 1 3 2-2 3-5.5Z" fill="#3d3dd7"/></svg>
              </span>
              <span className="icon">
                {/* YouTube */}
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3d3dd7" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.25" stroke="#bdbdf7" strokeWidth="1.5" fill="white"/><rect x="8" y="10" width="8" height="4" rx="1" fill="#3d3dd7"/><polygon points="11,11 14,12 11,13" fill="white"/></svg>
              </span>
              <span className="icon">
                {/* Discord */}
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3d3dd7" strokeWidth="1.5" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.25" stroke="#bdbdf7" strokeWidth="1.5" fill="white"/><path d="M16.5 15.5c-1.5 1-4.5 1-6 0l-.5-2c1.5.5 4.5.5 6 0l-.5 2Z" fill="#3d3dd7"/><circle cx="10" cy="12" r="1" fill="white"/><circle cx="14" cy="12" r="1" fill="white"/></svg>
              </span>
            </div>
          </div>
          <div className="footer-cols">
            <div className="footer-col">
              <p className="head">ECOSYSTEM</p>
              <ul>
                <li>Retail</li>
                <li>DeFi Innovators</li>
                <li>Blockchains</li>
                <li>Wallets</li>
                <li>Exchanges</li>
              </ul>
            </div>
            <div className="footer-col">
              <p className="head">TOKEN</p>
              <ul>
                <li>Tokenomics</li>
                <li>Staking</li>
                <li>Shopping</li>
                <li>Pools</li>
              </ul>
            </div>
            <div className="footer-col">
              <p className="head">GET TO KNOW US</p>
              <ul>
                <li>Company</li>
                <li>Team</li>
                <li>Advisors</li>
                <li>Contact</li>
                <li>Blog</li>
              </ul>
            </div>
            <div className="footer-col">
              <p className="head">ROADMAP</p>
              <ul>
                <li>Roadmap</li>
                <li>2022</li>
                <li>Updates</li>
                <li>Feedback</li>
                <li>Ideas</li>
              </ul>
            </div>
          </div>
        </div>
        <hr />
        <p className="footer-copyright">© 2023 All rights reserved to DebugAppFix</p>
      </footer>
    </div>
  );
};

export default LandingPage; 